import { getLocale, HttpStatusCode, request } from '@pb/utils'

import { ImageType } from 'features/Styleboard/types'

import { MyStyleboards, Profile } from './types'

const USERS_BASE = 'styleboardservice/users'
const MEDIA_BASE = `styleboardservice/media`
const STYLEBOARDS_BASE = 'styleboardservice/styleboards'

const extraConfig = {
  use: {
    apiVersion: false,
    locale: false,
  },
  // Since HMCORP_locale cookie is not always set we need to explicitly send it to the backend
  headers: {
    sb_hmcorp_locale: getLocale('mixed'),
  },
}
// GET
export const fetchProfile = async (id?: string): Promise<MyStyleboards> => {
  let response
  if (id) {
    response = await request.get(`${USERS_BASE}/${id}`, {
      params: {
        apiKey: process.env.STYLEBOARD_API_KEY,
      },
      ...extraConfig,
    })
    return response.data
  }

  response = await request.get(STYLEBOARDS_BASE, {
    params: {
      apiKey: process.env.STYLEBOARD_API_KEY,
    },
    ...extraConfig,
  })
  return response.data
}

// PUT
export const putProfile = async (profile: Profile): Promise<HttpStatusCode> => {
  const response = await request.put(`${USERS_BASE}/${profile.id}`, {
    data: profile,
    params: {
      apiKey: process.env.STYLEBOARD_API_KEY,
    },
    ...extraConfig,
  })

  return response.status
}

export const uploadImage = async (file: File, type: ImageType): Promise<string> => {
  const formData = new FormData()
  formData.append('file', file)
  const response = await request.put(MEDIA_BASE, {
    data: formData,
    params: {
      type,
      apiKey: process.env.STYLEBOARD_API_KEY,
    },
    shouldTrimData: false,
    ...extraConfig,
  })
  return response.headers.link
}
